import React from "react";
import classNames from "classnames";
import {formatPureAttributes} from "./index";
import Select from "../../Select";

export const HeaderNode = (Tag, props) => {
    return <Tag {...formatPureAttributes(props.node.data.get('attributes'))} className={classNames(props.className)}>{props.children}</Tag>;
}

const isHeader = (value) => value.blocks.find((block) => block.type + "" === 'header');

const headers = [1,2,3,4,5,6].map((key) => (
    {key: "h" + key, label: key + ". Fejléc"}
));

export class HeaderEdit extends React.Component {
    render() {
        const node = isHeader(this.props.value);
        return (
            <div className="headers">
                <Select
                    disabled={this.props.disabled}
                    storeType="local"
                    options={headers}
                    valueKey="key"
                    labelKey="label"
                    objectValue={false}
                    isClearable={true}
                    label={false}
                    placeholder="Fejléc"
                    isSearchable={false}
                    value={node ? (node.data.get("tagname") || null) : null}
                    saveChanges={(field, tagname) => {
                        let editor = null;
                        if (tagname !== null) {
                            if (!isHeader(this.props.value)) {
                                editor = this.props.editor
                                    .setBlocks({type: 'header', data: {tagname}})
                                    .focus();
                            } else {
                                editor = this.props.editor
                                    .setBlocks({type: 'header', data: {tagname}})
                                    .focus();
                            }
                        } else if (isHeader(this.props.value)) {
                            editor = this.props.editor
                                //.unwrapNodeByKey(node.key)
                                .setBlocks('paragraph')
                                .focus();
                        }
                        this.props.saveEditing && this.props.saveEditing(editor);
                    }}
                />
            </div>
        );
    }
}